class SponsoredTeamForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    const btn = this.querySelector('[type="submit"]');
    const honeypot = this.querySelector('[name="contact[company]"]');
    const tsField = this.querySelector('[name="contact[_timestamp]"]');

    // Set timestamp on load
    if (tsField) tsField.value = String(Date.now());

    // Enable submit button (bots without JS can't submit)
    if (btn) btn.disabled = false;

    form.addEventListener('submit', function (e) {
      // Honeypot check
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }

      // Time check (< 3s after page load = likely bot)
      if (tsField) {
        var elapsed = Date.now() - Number(tsField.value);
        if (elapsed < 3000) {
          e.preventDefault();
          return;
        }
      }
    });
  }
}

if (!customElements.get('sponsored-team-form')) {
  customElements.define('sponsored-team-form', SponsoredTeamForm);
}
